module.exports = __webpack_public_path__ + "static/pp_geokodowanie-80c6c4587c4bcd1f0c0242597282a18e.gif";